const CACHE_PREFIX = 'ubiquity2:yardLayoutTier2:';
const CACHE_TTL_MS = 60 * 60 * 1000; // 1 hour

function readCache(yardId) {
  try {
    const raw = sessionStorage.getItem(CACHE_PREFIX + yardId);
    if (!raw) return null;
    const { value, expiresAt } = JSON.parse(raw);
    if (Date.now() > expiresAt) {
      sessionStorage.removeItem(CACHE_PREFIX + yardId);
      return null;
    }
    return value;
  } catch {
    return null;
  }
}

function writeCache(yardId, value) {
  try {
    sessionStorage.setItem(
      CACHE_PREFIX + yardId,
      JSON.stringify({ value, expiresAt: Date.now() + CACHE_TTL_MS })
    );
  } catch {
    // sessionStorage unavailable (private browsing quota, etc.) — silently skip
  }
}

/**
 * @param {number|string} yardId
 * @param {{ signal?: AbortSignal, timeoutMs?: number }} [opts]
 * @returns {Promise<boolean>} true if Tier 1 tiles are available for this yard
 */
export function probeYardTier1(yardId, { signal, timeoutMs = 4000 } = {}) {
  const cached = readCache(yardId);
  if (cached !== null) return Promise.resolve(cached);

  const tileUrl = `https://yardimages.copart.com/styles/yard${yardId}-lite/0/0/0.png`;

  return new Promise((resolve) => {
    let settled = false;

    function settle(value, isError = false) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      if (isError && value === false) {
        // Log non-404 failures (DNS, 5xx) so they surface in user-reported issues.
        // We can't distinguish 404 from other onerror causes with Image, so always warn.
        console.warn(`[YardLayout] Tier 1 probe failed for yard ${yardId}:`, tileUrl);
      }
      writeCache(yardId, value);
      resolve(value);
    }

    const timer = setTimeout(() => settle(false, true), timeoutMs);

    // Abort signal: treat abort as a non-cached probe failure (don't persist false).
    if (signal) {
      signal.addEventListener('abort', () => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        // Do NOT write to cache — component was unmounted mid-probe.
        resolve(false);
      }, { once: true });
    }

    const img = new Image();
    img.onload = () => settle(true);
    img.onerror = () => settle(false, true);
    img.src = tileUrl;
  });
}
